module.exports = __webpack_public_path__ + "static/img/iconmenu09_white.9a296801.svg";